import React from "react";
// ANT DESIGN COMPONENTS
import { Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
// INTERFACES
import { TableNoDataBoxInterface } from "../../../interfaces/Components.interface";

function TableNoDataBox({ isError, errorMessage, noItemsFound }: TableNoDataBoxInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__flexCenter component__table__noDataBox">
      <div>
        {isError ? (
          <Tooltip
            title={errorMessage}
            overlayInnerStyle={{ maxWidth: "450px", fontSize: "12px" }}
            placement="bottom"
          >
            <div style={{ cursor: "pointer" }}>
              <FontAwesomeIcon icon={faWarning} className="component__table__noDataIcon" />
              <p>No data available for the selected filters</p>
              <p style={{ fontSize: "11px", opacity: 0.6 }}>Hover for details</p>
            </div>
          </Tooltip>
        ) : (
          <p>{noItemsFound}</p>
        )}
      </div>
    </div>
  );
}

export default TableNoDataBox;
